import { render, staticRenderFns } from "./serbestfatura.vue?vue&type=template&id=7342a1b6&scoped=true&"
import script from "./serbestfatura.vue?vue&type=script&lang=js&"
export * from "./serbestfatura.vue?vue&type=script&lang=js&"
import style0 from "./serbestfatura.vue?vue&type=style&index=0&id=7342a1b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7342a1b6",
  null
  
)

export default component.exports